export class FeedbackType {
  public constructor() {
    this.Code = "";
    this.Type = "";
    this.EnumType = "";
    this.RowPointer = "";
  }

  public Type: string;
  public EnumType: string;
  public Code: string;
  public RowPointer: string;
}
